import { useEffect, useState } from "react";
import { Plus, Save, Trash2, Zap } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

export function QuickRepliesSettingCard() {
  const [items, setItems] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/quick-replies").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  const set = (i, patch) => setItems(items.map((it, j) => (j === i ? { ...it, ...patch } : it)));
  const save = async () => {
    const clean = items.filter((it) => it.label.trim() && it.text.trim());
    setSaving(true);
    try {
      await api.put("/settings/quick-replies", { items: clean });
      setItems(clean); toast.success(`${clean.length} balasan cepat tersimpan`);
      window.dispatchEvent(new CustomEvent("fasnet:quick-replies-changed"));
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  if (items === null) return null;
  return (
    <Card className="bg-card border-border" data-testid="quick-replies-settings">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center gap-2"><Zap className="w-4 h-4 text-amber-400" /> Balasan Cepat Chat Admin</CardTitle>
        <p className="text-xs text-muted-foreground">Template yang muncul sebagai tombol di atas kolom chat admin. Gunakan <code className="px-1 rounded bg-muted">{"{salam}"}</code> untuk otomatis menjadi pagi/siang/sore/malam saat dipakai.</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {items.map((it, i) => (
          <div key={i} className="rounded-lg border border-border p-3 space-y-2" data-testid={`quick-reply-item-${i}`}>
            <div className="flex gap-2 items-center">
              <Input value={it.label} onChange={(e) => set(i, { label: e.target.value })} placeholder="Judul tombol (mis. FUP Starlink)" maxLength={60} className="h-9 text-sm" data-testid={`quick-reply-label-${i}`} />
              <Button size="icon" variant="ghost" className="text-rose-400 shrink-0" onClick={() => setItems(items.filter((_, j) => j !== i))} title="Hapus template" data-testid={`quick-reply-del-${i}`}><Trash2 className="w-4 h-4" /></Button>
            </div>
            <Textarea value={it.text} onChange={(e) => set(i, { text: e.target.value })} rows={Math.min(10, Math.max(3, it.text.split("\n").length + 1))} maxLength={2000} placeholder="Isi pesan..." className="text-sm" data-testid={`quick-reply-text-${i}`} />
            <div className="text-[10px] text-muted-foreground text-right">{it.text.length}/2000</div>
          </div>
        ))}
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => setItems([...items, { label: "", text: "Selamat {salam} Pak.\n" }])} data-testid="quick-reply-add"><Plus className="w-4 h-4 mr-1" /> Tambah Template</Button>
          <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="quick-reply-save"><Save className="w-4 h-4 mr-1" /> {saving ? "Menyimpan..." : "Simpan"}</Button>
        </div>
      </CardContent>
    </Card>
  );
}
